import { render, staticRenderFns } from "./PresenterDisplay.vue?vue&type=template&id=12eec449&"
import script from "./PresenterDisplay.vue?vue&type=script&lang=js&"
export * from "./PresenterDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports